import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@api/base-services-axios-rtx";

import { createQuery } from "@/shared/helpers/create-query.helper";
import { OwnersEndpoints } from "@/shared/models/endpoints/owners.endpoint";
import { OwnerListResponse } from "@/shared/models/interfaces/response/owners/owner-list-responses.interface";
import { OwnerDetailResponse } from "@/shared/models/interfaces/response/owners/owner-detail-responses.interface";

import { CommonOwnerResponse } from "../../../models/interfaces/response/owners/owner-common.interface";
import { IOWNERS_LIST_FILTERS } from "./utils/owner-services.util";
import { detailOwnerAdapter } from "./adapters/detail.adapter";
import { detailCommonOwnerAdapter } from "./adapters/detail-common.adapter";

export const OwnersQueryServices = createApi({
  reducerPath: "owners-services",
  baseQuery: axiosBaseQuery(),

  endpoints: builder => ({
    getListOwner: builder.mutation({
      query: (values: { params: IOWNERS_LIST_FILTERS }) => {
        return {
          url: OwnersEndpoints.OwnersList + createQuery(values.params),
          method: "GET"
        };
      },
      transformResponse: (response: OwnerListResponse, meta, arg) => response
    }),

    getDetailOwner: builder.mutation({
      query: (values: { id: number }) => ({
        url: OwnersEndpoints.ownersDetail(values.id),
        method: "GET"
      }),
      transformResponse: (response: OwnerDetailResponse) =>
        detailOwnerAdapter(response.data)
    }),

    UpdateOwner: builder.mutation({
      query: (values: { id: number; body: any }) => {
        return {
          url: OwnersEndpoints.ownersUpdate(values.id),
          method: "POST",
          body: values.body
        };
      },
      transformResponse: (response: any, meta, arg) => response.data
    }),

    getCommonOwnerDetail: builder.mutation({
      query: (values: { owner_id: number; people_id: number }) => {
        return {
          url: OwnersEndpoints.commonProperties(values.owner_id, values.people_id),
          method: "GET"
        };
      },
      transformResponse: (response: CommonOwnerResponse, meta, arg) =>
        detailCommonOwnerAdapter(response.data)
    })
  })
});

export const {
  useGetListOwnerMutation,
  useGetDetailOwnerMutation,
  useGetCommonOwnerDetailMutation,
  useUpdateOwnerMutation
} = OwnersQueryServices;
